import {Typography} from '@sollapay/ui';
import {formatNIS} from '@sollapay/utils';

import type {TypographyProps} from '@sollapay/ui';
import type {FC} from 'react';

export interface AmountCellProps {
  amount: string;
  color?: TypographyProps['color'];
}

/** NIS-formatted amount cell, digit-aligned via tabular-nums — shared by every table showing a plain money column. */
export const AmountCell: FC<AmountCellProps> = ({amount, color = 'secondary'}) => (
  <Typography size="sm" weight="medium" color={color} className="tabular-nums">
    {formatNIS(amount)}
  </Typography>
);
